import React from 'react'
import { useParams } from 'react-router'

export default function Error404Page() {
  const { lng } = useParams()
  return (
    <div className="flex min-h-screen w-full">
      <div className="m-auto text-center">
        <h1 className="mb-2 text-9xl font-bold">404</h1>
        <p className="text-2xl uppercase">{lng == 'en' ? 'oops! nothing was found' : 'عذرا! لم يتم العثور على الصفحة'}</p>
      </div>
    </div>
  )
}
